export default "__VITE_ASSET__D5It7AeC__"